import Masonry from "masonry-layout";

var websitesFilter = (function () {

	function setup() {
		
		var grid = new Masonry('.sites-grid', {columnWidth: 10 });

		$('.websitesPage').on('change', 'input[type=radio]', function () {

			let region = $('.websitesPage input[name="regionType"]:checked').val();
			//let sector = $('.websitesPage input[name="sectorType"]:checked').val();

			if (region == 'all') {//} && sector == 'all') {
				$('.country').removeClass('filtered').show();
				//$('.sector').removeClass('filtered').show();
			} else {
				let matchingCountries = region != 'all' ? $('.country[data-region="' + region + '"]') : $('.country');
				//let matchingSectors = sector != 'all' ? $('.sector[data-sector="' + sector + '"]') : $('.sector');

				$('.country').addClass('filtered').hide();
				//$('.sector').addClass('filtered').hide();

				matchingCountries.removeClass('filtered').show();
				//matchingSectors.removeClass('filtered').show();

				$('.country').each(function (i, e) {
					let $e = $(e);
				//	console.log('Country:' + $('h3', $e).text() + ' Is filtered: ' + $(e).hasClass('filtered') + ' Filtered count:' + $('.sector', $e).not('.filtered').length);

					if (!$e.hasClass('filtered')) {
						if ($('.sector', $e).not('.filtered').length>0) {
							$e.removeClass('filtered').show();
						} else {
							$e.addClass('filtered').hide();
						}
					}
				});
			}

			grid.layout();
		});
	}

	return {
		init: function () {
			$(function () {
				setup();
			});
		}
	};
})();

export var websitesFilter;